import HttpService from './base.service/HttpService'

export default class DashboardService extends HttpService {
  getDetailSpklu (param) {
    const api = process.env.VUE_APP_API + '/api/spklu/detail-spklu'
    return this.get(param, api)
  }

  getCardAndDiagram (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/detail-by-spklu'
    return this.get(param, api)
  }

  getSpkluAC (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/spklu-ac'
    return this.get(param, api)
  }

  getSpkluFastCharging (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/spklu-dc2'
    return this.get(param, api)
  }

  getSpkluFastChargingTable (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/spklu-dc2-detail'
    return this.get(param, api)
  }

  getPgb (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/detail-charger-connector'
    return this.get(param, api)
  }

  getDataKendaraanCard (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/summary-monitoring-ev-trx'
    return this.get(param, api)
  }

  getDataKendaraanPgb (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/monitoring-ev-trx'
    return this.get(param, api)
  }

  getDataExcel (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/export-monitoring-ev-trx'
    return this.getFile({}, api, param.name)
  }

  getDetailTransaksi (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/detail-trx'
    return this.get(param, api)
  }

  getDetailTransaksiExcel (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/export-detail-trx'
    return this.getFile(param, api, param.name)
  }

  getDetailUnavailableAC (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/detail-unavailable'
    return this.get(param, api)
  }

  getDetailUnavailableACExcel (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/export-detail-unavailable'
    return this.getFile({}, api, param.name)
  }

  getDetailUnavailableDC (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/detail-unavailable-dc'
    return this.get(param, api)
  }

  getDetailUnavailableDCExcel (param) {
    const api = process.env.VUE_APP_API + '/dashboard-g20/export-detail-unavailable-dc'
    return this.getFile({}, api, param.name)
  }

  getListInstansi (param) {
    const api = process.env.VUE_APP_API + '/ktt-g20/list-instansi-postpaid'
    return this.get(param, api)
  }

  aktivasiUserPasca (param) {
    const api = process.env.VUE_APP_API + '/ktt-g20/activate-postpaid-user'
    return this.post(param, api)
  }

  a () {
    const api = 'http://10.14.205.128:8080/ocpp-central-system/heartbeat'
    return this.get({}, api)
  }
}
